import React from 'react';

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import Formatter from '../../utils/Formatter';
import AnalysisTools from '../../utils/AnalysisTools';
const NestedLoanBreakdown = ({ loan, account, recommendedPlan }) => {
    return (
        <>
            <TableRow key={loan.id}>

                <TableCell colSpan={2}>
                    &nbsp;&nbsp;&nbsp;  -  &nbsp;&nbsp;   {loan.type.name}</TableCell>
                <TableCell>${Formatter.money(loan.balance)}</TableCell>
                <TableCell>{Formatter.statusText(loan.status)}</TableCell>
                <TableCell>
                    {Formatter.repaymentPlanText(
                        AnalysisTools.getCurrentRepaymentPlan(
                            loan.id,
                            account.msd.details
                        )
                    )}
                </TableCell>
                <TableCell>{Formatter.money(loan.loanInterestRate)}%</TableCell>
                <TableCell>${Formatter.money(loan.mmp)}</TableCell>
                <TableCell>
                    {Formatter.repaymentPlanText(recommendedPlan)}
                </TableCell>

            </TableRow>
        </>
    )

}
export default NestedLoanBreakdown;